import { render } from "./HHReferralDocuments.vue?vue&type=template&id=5cef93ab&ts=true"
import script from "./HHReferralDocuments.ts?vue&type=script&lang=ts&external"
export * from "./HHReferralDocuments.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__